<template>
<div id="contents">

  <div id="works" class="page_contents">

    <div id="works_contents">
      <div id="works_photographing_index">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/works/program/title.png" width="225" alt="WORKS" />
            <span>制作実績</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <worksPageNav/>

        <div id="works_photographing_index_main" class="page_main_contents">

          <div class="photographing">
            <h3 class="photographing_title">撮影</h3>
            <p class="photographing_read">情報番組、ドキュメンタリー、ドラマ、PR動画、CMなど、幅広いジャンルのロケーション撮影に対応でき、各作品の狙いに沿った表現をかたちにできるよう、最新の機材を用意。映像制作の品質向上を実現しています。長期にわたる海外ロケやドキュメンタリーといった、撮影チャンスが限られ、不測の事態が起きやすい現場でも、イメージ通りの映像を撮れるようノウハウを蓄積、活用しています。</p>
            <div class="photographing_inner">
              <ul>
                <li><img src="../assets/img/works/photographing/shooting01.jpg" width="305" alt="撮影機材の画像" /></li>
                <li><img src="../assets/img/works/photographing/shooting02.jpg" width="305" alt="撮影機材の画像" /></li>
                <li><img src="../assets/img/works/photographing/shooting03.jpg" width="305" alt="撮影機材の画像" /></li>
              </ul>
            </div><!-- .photographing_inner -->

            <div class="photographing_works_list">
              <h4>実績：</h4>
              <div class="photographing_works_list_inner">
                <p>テレビ朝日／BS朝日／AbemaTV／NHK／日テレ／TBS／フジテレビ／テレビ東京／BSテレビ東京／WOWOW／テレビ東京制作／東京サウンドプロダクション／コスモスペ
                ース／JTB／小田急エージェンシー／あしかがフラワーパーク／他</p>
              </div><!-- .works_photographing_list_inner -->
            </div><!-- .works_photographing_list -->
          </div><!-- .photographing -->

          <div class="editing">
            <h3 class="photographing_title">編集・ＭＡ</h3>
            <p class="photographing_read">ドキュメンタリーからバラエティーまでのあらゆる映像コンテンツや、クライアントのさまざまなニーズに対応できるよう、高度な編集技術を備えた編集・MA環境を用意しています。</p>

            <div class="editing_contents">
              <div class="editing_box">
                <p class="editing_box_img"><img src="../assets/img/works/photographing/ma01.jpg" width="305" alt="撮影機材の画像" /></p>
                <div class="editing_box_inner">
                  <h3>&#9312;HDリニア編集室(2室)</h3>
                  <p>SONYシステムとDEKO/TFXの組み合わせにより、オールラウンドに映像編集の対応が可能です。</p>
                </div><!-- .editing_box_inner -->
              </div><!-- .editing_box -->

              <div class="editing_box">
                <p class="editing_box_img"><img src="../assets/img/works/photographing/ma02.jpg" width="305" alt="撮影機材の画像" /></p>
                <div class="editing_box_inner">
                  <h3>&#9313;HD/4Kノンリニア編集室(2室)</h3>
                  <p>AVIDのオンライン編集室です。4K/HDR編集およびPremiereシステムにも対応しています。</p>
                </div><!-- .editing_box_inner -->
              </div><!-- .editing_box -->

              <div class="editing_box">
                <p class="editing_box_img"><img src="../assets/img/works/photographing/ma03.jpg" width="305" alt="撮影機材の画像" /></p>
                <div class="editing_box_inner">
                  <h3>&#9314;テロップシステム：DEKO/TFX</h3>
                  <p>SONYシステムとDEKO/TFXの組み合わせにより、オールラウンドな番組に対応します。</p>
                </div><!-- .editing_box_inner -->
              </div><!-- .editing_box -->

              <div class="editing_box editing_box_last">
                <p class="editing_box_img"><img src="../assets/img/works/photographing/ma05.jpg" width="626" alt="撮影機材の画像" /></p>
                <div class="editing_box_inner">
                  <h3>&#9315;MA室(2室)</h3>
                  <p>テレビ番組、PR動画、CMなど幅広いジャンルの作品で稼働中です。DAWはPro Toolsを採用しており、XDCAM納品にも対応します。</p>
                </div><!-- .editing_box_inner -->
              </div><!-- .editing_box -->
            </div><!-- .editing_contents -->

          </div><!-- .editing -->

        </div><!-- #works_program_show_main -->

      </div><!-- #works_photographing_index -->
    </div><!-- #works_contents -->
  </div><!-- #works -->



</div><!-- #contents -->
</template>

<script>
import worksPageNav from './shared/worksPageNav.vue'
export default {
  name: 'photographing_index',
  components: {
    worksPageNav
  },
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/photographing_index.vue